import type { FunctionComponent } from 'react';
import * as styles from './BreakLine.module.css';

const BreakLine: FunctionComponent = () => (
  <div className={styles.breakLine} data-testid="break-line" />
);

export default BreakLine;
